import { render, staticRenderFns } from "./v-date-input.vue?vue&type=template&id=530cca40&scoped=true&"
import script from "./v-date-input.vue?vue&type=script&lang=js&"
export * from "./v-date-input.vue?vue&type=script&lang=js&"
import style0 from "./v-date-input.vue?vue&type=style&index=0&id=530cca40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cca40",
  null
  
)

export default component.exports